export const environment = {
    production: true,
    socketUrl: '/api/Game',
    translatesUrl: '/api/Zeppelinapi/Translates',
    uiConfigUrl: '/api/Zeppelinapi/GetUiConfig',
    token: 'sessionId'
};
